import axios from "axios";

export const BACKEND = process.env.REACT_APP_BACKEND_URL;
export const boApi = axios.create({ baseURL: `${BACKEND}/api/bo` });
const KEY = "gw_bo_token";

export const getToken = () => sessionStorage.getItem(KEY);
export const setToken = (t) => (t ? sessionStorage.setItem(KEY, t) : sessionStorage.removeItem(KEY));

boApi.interceptors.request.use((cfg) => {
  const t = getToken();
  if (t) cfg.headers.Authorization = `Bearer ${t}`;
  return cfg;
});
boApi.interceptors.response.use((r) => r, (e) => {
  if (e?.response?.status === 401 && getToken()) {
    setToken(null);
    window.dispatchEvent(new Event("bo-logout"));
  }
  return Promise.reject(e);
});

export function errMsg(e) {
  const d = e?.response?.data?.detail;
  if (d == null) return e?.message || "Something went wrong";
  if (typeof d === "string") return d;
  if (Array.isArray(d)) return d.map((x) => x?.msg || JSON.stringify(x)).join(" ");
  return d.msg || String(d);
}

export async function download(path, params, filename) {
  const r = await boApi.get(path, { params, responseType: "blob" });
  const url = URL.createObjectURL(r.data);
  const a = document.createElement("a");
  a.href = url;
  a.download = filename;
  a.click();
  URL.revokeObjectURL(url);
}

const nf2 = new Intl.NumberFormat("en-IN", { minimumFractionDigits: 2, maximumFractionDigits: 2 });
const nf0 = new Intl.NumberFormat("en-IN", { maximumFractionDigits: 0 });
export const inr = (v) => (v == null || isNaN(v) ? "—" : `${v < 0 ? "-" : ""}₹${nf2.format(Math.abs(v))}`);
export const num = (v) => (v == null || isNaN(v) ? "—" : nf0.format(v));
export const dec = (v) => (v == null || isNaN(v) ? "—" : nf2.format(v));
export const tone = (v) => (v > 0 ? "text-up" : v < 0 ? "text-down" : "text-muted-foreground");
const dtf = new Intl.DateTimeFormat("en-IN", { timeZone: "Asia/Kolkata", day: "2-digit", month: "short", year: "numeric", hour: "2-digit", minute: "2-digit", second: "2-digit", hour12: false });
export const ist = (s) => (s ? `${dtf.format(new Date(s))}` : "—");
export const todayIST = () => new Date(Date.now() + 5.5 * 3600e3).toISOString().slice(0, 10);
